const EixX = ({ x, y, payload, width }) => {
	if (payload.value === 50) return null
	if (width < 400 && payload.value % 20 !== 0) return null

	return (
		<text
			x={x}
			y={y}
			dy={7}
			dx={payload.value === 100 ? -15 : -8}
			fill='#888'
			className='e6'
		>
			{payload.value}
		</text>
	)
}
export default EixX
